import { handleVersionMismatch } from 'actions/versionSync';
import * as MessagesActionTypes from 'actiontypes/messages';
import { VersionMismatch } from 'services/BaseService';
import MassageService from 'services/MessagesService';

export const FEED_MESSAGES = 'feedMessages';
export const INTERACTIONS = 'interactions';

const messagesService = new MassageService();

/** ----------------------------------------------------------------------------
 * FETCH MESSAGES
 -----------------------------------------------------------------------------*/
export default function fetch() {
  return async (dispatch: Function) => {

    if (document.hidden) {

      document.onvisibilitychange = () => {
        document.onvisibilitychange = null;
        dispatch(fetch());
      };

      return dispatch(fetchQueued());
    }

    document.onvisibilitychange = null;
    dispatch(fetchRequested());

    try {
      const { data } = await messagesService.fetch();
      dispatch(fetchSuccess(data));
    } catch (e) {
      if (e instanceof VersionMismatch) {
        dispatch(handleVersionMismatch(e));
      }

      // TODO: throw an error when IsSuccess is false?
      dispatch(fetchFailure(e));
    }
  };
}

export const fetchRequested = (which?: 'feedMessages' | 'interactions') => {
  switch (which) {
    case FEED_MESSAGES:
      return { type: MessagesActionTypes.FETCH_FEED_MESSAGES_REQUESTED };
    case INTERACTIONS:
      return { type: MessagesActionTypes.FETCH_INTERACTIONS_REQUESTED };
    default:
      return { type: MessagesActionTypes.FETCH_ALL_REQUESTED };
  }
};

export const fetchSuccess = (data: any, type = MessagesActionTypes.FETCH_ALL_SUCCESS) => ({
  type,
  payload: {
    interactions: data.interactions,
    feedMessages: data.feedMessages,
  },
});

export const fetchFailure = (error: any) => ({
  type: MessagesActionTypes.FETCH_ALL_FAILURE,
  error: true,
  status: error.response && error.response.status,
});

const fetchQueued = () => ({ type: MessagesActionTypes.FETCH_QUEUED });